import { loadablePage } from 'src/utils/loadable';
import { PurchaseFlowModalBodyProps } from './PurchaseFlowModalBody.component';
import { ModalHelperProps } from 'src/components/Modal/Modal.types';

export default loadablePage<
  React.FC<ModalHelperProps & PurchaseFlowModalBodyProps>
>(() => import('./PurchaseFlowModal.component'));
